import React, { useEffect } from "react";
import envVariables from "../../data/envVariables";
import Button from "../ui/Button";
import { isDealPreAvinode } from "../../utilities/settings";

const PortalOpsStageBasedCtas = ({ deal, onShowOptions }) => {
    const legId = deal.daM_Ref;
    const briefUrl = `/flight-brief?lo=${legId}`;
    const downloadQuoteBriefUrl = `${envVariables.documentBase}/QuotebuilderDownload/download-quotebrief?lo=${legId}`;

    useEffect(() => {
        //console.log(deal)
    }, [deal]);

    const openBriefPage = () => {
        window.open(briefUrl, "_blank");
    };
    const openBriefPageDL = () => {
        window.open(downloadQuoteBriefUrl, "_blank");
    };

    const openAddPax = () => {
        window.open(`/add-passengers-to-booking/${legId}`, "_blank");
    };

    return (
        <>
            <div className="portal-cta-grid">
                {!isDealPreAvinode(deal) && (
                    <Button classNames={["button button--secondary"]} onClick={openBriefPage}>
                        Brief page
                    </Button>
                )}
                {!isDealPreAvinode(deal) && (
                    <Button classNames={["button button--secondary"]} onClick={openBriefPageDL}>
                        Brief PDF
                    </Button>
                )}
                {!isDealPreAvinode(deal) && (
                    <Button classNames={["button button--secondary"]} onClick={openAddPax}>
                        Add Pax
                    </Button>
                )}
            </div>
        </>
    );
};

export default PortalOpsStageBasedCtas;
